import axios from 'axios'
import { IUser } from 'services/auth/auth.types'
import { IAppleSocialLoginPayload, IGoogleSocialLoginPayload } from './social.types'

export const ApiPathsSocial = {
  google: '/api/auth/social/google',
  apple: '/api/auth/social/apple',
}

export const socialGoogleLogin = async (url: string, { arg }: { arg: IGoogleSocialLoginPayload }): Promise<IUser> => {
  const { data } = await axios.post<IUser>(url, arg)
  return data
}

export const socialAppleLogin = async (url: string, { arg }: { arg: IAppleSocialLoginPayload }): Promise<IUser> => {
  const { data } = await axios.post<IUser>(url, arg)
  return data
}
